import React, { FC, useEffect } from 'react';

import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import DoneImg from '~/assets/images/done_v2.webp';
import DonePreviewImg from '~/assets/images/done_v2_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import analytics from '~/services/analytics';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  pauseDuration: number;
  onClose: () => void;
};

const PauseSuccessModal: FC<Props> = ({ pauseDuration, onClose }) => {
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);
  const profile = useAppSelector((state) => state.profile);

  const { t } = useTranslation('modal');

  useEffect(() => {
    analytics.trackEvent('holiday pause - pause success modal view', {
      option: pauseDuration,
      subscription_id: profile.user_subscription.id,
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Image src={DoneImg} preview={DonePreviewImg} />
      </div>

      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('pause_sub_success.title_v2', {
          duration: pauseDuration,
          defaultValue:
            'Your plan is successfully paused for {{duration}} months',
        })}
      </Typography>

      <Typography
        variant={Typographies.BODY_LARGE}
        component="div"
        className={styles.text}
      >
        <div className={styles.text}>
          {t(
            'pause_sub_success.text',
            'You can unpause it in Subscription section on your profile page',
          )}
        </div>
        <div className={styles.text}>
          <Trans
            i18nKey="pause_sub_success.subtext_v2"
            components={{ br: <br /> }}
            defaults="We'll send you a reminder before your pause ends, so you can jump back in when you're ready.<br/>Enjoy your break!"
          />
        </div>
      </Typography>

      <div className={styles.buttons_container}>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          fullWidth={!isDesktop}
        >
          {t('general:got_it', 'Got it')}
        </Button>
      </div>
    </div>
  );
};

export default PauseSuccessModal;
